import React from "react";

//Props
//name - label for the file picker field
//id - string optional - used to set the input's id, please use if using multiple file pickers on the same page
//mimetypes - string representing the mimetypes that should be accepted by the file picker
//multiple - optional flag - can be set to true or false or not passed on at all, regardless if it is set to true then multi file picker is used instead of single file picker
//size - optional int - can be set to a particular integer value indicating the max file size we want to allow to be uploaded using this file picker
//required - boolean
//Note:- size is always in Bytes

export default function ECLFileInput(props) {
   return (
      <>
         <div className="file-picker-container">
            <label
               style={{ display: props.name ? "block" : "none" }}
               data-testid={props.id}
               htmlFor={props.id}
            >
               {props.name}
               {props.required && <span className="required-input"> *</span>}
            </label>
            {props.multiple ? (
               <input
                  data-size={props.size}
                  type="file"
                  id={props.id}
                  className="file-picker-input"
                  accept={props.mimetypes}
                  multiple
               />
            ) : (
               <input
                  data-size={props.size}
                  type="file"
                  id={props.id}
                  className="file-picker-input"
                  onChange={props.onChange}
                  accept={props.mimetypes}
                  required={props.required}
               />
            )}
         </div>
      </>
   );
}
